import { createContext, Dispatch, useReducer } from 'react'
import {
  AnalysisReportOrderField,
  AnalysisReportType,
  OrderDirection,
} from 'generated/graphql'
import analysisReportsReducer, {
  TAnalysisReportsAction,
  TAnalysisReportsState,
} from './analysisReportsReducer'

type TAnalysisContext = {
  state: TAnalysisReportsState
  dispatch: Dispatch<TAnalysisReportsAction>
}
export const getInitialState = (): TAnalysisReportsState => {
  return {
    filterBy: {
      type: AnalysisReportType.COMPANY,
    },
    orderBy: {
      field: AnalysisReportOrderField.CREATED_AT,
      direction: OrderDirection.DESC,
    },
    pagination: {
      page: 1,
      pageSize: 20,
    },
  }
}

const AnalysisReportsContext = createContext<TAnalysisContext>({
  state: getInitialState(),
  dispatch: () => null,
})

const AnalysisReportsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    analysisReportsReducer,
    getInitialState(),
  )

  return (
    <AnalysisReportsContext.Provider value={{ state, dispatch }}>
      {children}
    </AnalysisReportsContext.Provider>
  )
}

export { AnalysisReportsContext, AnalysisReportsContextProvider }
